import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, } from "react-router-dom";
import AuthFooter from "./footer/AuthFooter";
import AuthNavbar from "./navbar/AuthNavbar";
import { useCookies } from "react-cookie";
const Auth = () => {
    const navigate = useNavigate();
    const [cookies, setCookie] = useCookies();
    const checkUserToken = () => {
        const userToken = sessionStorage.getItem('authorization');
        if (userToken) {
            return navigate('/');
        }
    }
    useEffect(() => {
        checkUserToken();
    });
    return (
        <React.Fragment>
            <AuthNavbar />
            <Outlet />
            <AuthFooter />
        </React.Fragment>
    );
}
export default Auth;